'use client';

import { useEffect, useRef } from 'react';

export function OkendoAllReviews() {
  const widgetContainer = useRef(null);

  const initialiseWidget = () =>
    window.okeWidgetApi?.initWidget(widgetContainer.current);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (window.okeWidgetApi?.initWidget) {
      initialiseWidget();
    } else {
      document.addEventListener('oke-script-loaded', initialiseWidget);
    }

    return () => {
      document.removeEventListener('oke-script-loaded', initialiseWidget);
    };
  }, []);

  return <div ref={widgetContainer} data-oke-widget />;
}
